import { Component } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {LoginRequest} from "../../../../modules/auth/models/login-request";
import {AuthService} from "../../../../modules/auth/services/auth-service";
import {ToastrService} from "ngx-toastr";
import {Router} from "@angular/router";
import {BaseResponse} from "../../../models/base-response";
import {Token} from "../../../../modules/auth/models/token";
import {Title} from "@angular/platform-browser";

@Component({
    selector: 'app-login-imed',
    templateUrl: './login-imed.component.html',
    styleUrl: './login-imed.component.css',
    standalone: false
})
export class LoginImedComponent {


  constructor(private titleService: Title) {
    this.titleService.setTitle('IMed - Gestão de Pacientes');
    this.setFavicon('faviconImed.ico');
  }

  setFavicon(faviconUrl: string): void {
    const link: HTMLLinkElement =
      document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'icon';
    link.href = faviconUrl;
    document.getElementsByTagName('head')[0].appendChild(link);
  }
}
